<template>
  <div class="container lg:px-container">
    <div class="card px-4 py-2 lg:px-12 lg:py-8 my-12">
      <div
        v-if="html"
        v-html="html"
      />
      <div v-if="showList || termKey === 'cookie'">
        <VinTitle
          el="h1"
          :text="`${$t('plz_review_terms_list')} ${prettyKey}`"
          class="mb-8"
        />
        <div
          v-for="t in filteredTerms"
          :key="t.id"
          class="cursor-pointer text-grey-dk hover:text-primary-dk hover:underline my-4 text-xl"
          @click="handleTermSelect(t)"
        >
          {{ $t(t.name) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import get from 'lodash.get'

import termsSetup from './termsSetup'
export default {
  name: 'TermsDefault',
  setup () {
    const { host, isLocal, path } = termsSetup()
    return { host, isLocal, path }
  },
  data () {
    return {
      html: '',
      terms: [],
      showList: false,
    }
  },
  computed: {
    termKey () {
      return get(this.$route, 'meta.termKey', 'tos')
    },
    prettyKey () {
      switch (this.termKey) {
        case 'cookie':
          return this.$t('cookie_banner_cookie_policy_cta')
        case 'privacy':
          return this.$t('privacy_policy')
        default:
          return this.$t('terms_of_service')
      }
    },
    termName () {
      return get(this.$route, 'query.name')
    },
    filteredTerms () {
      return this.terms.filter(t => t.name.toLowerCase().indexOf(this.termKey) >= 0)
    },
  },
  watch: {
    async termName () {
      this.html = '<div></div>'
      await this.fetchTerms()
    },
  },
  created () {
    try {
      this.fetchTerms()
    } catch (error) {
      console.error('error fetching terms', error)
      throw error
    }
  },
  methods: {
    async fetchTerms () {
      try {
        const { data } = await axios.get(this.path)
        this.terms = data.terms
        if (this.termName) {
          this.fetchTermForCountry()
        } else {
          this.showList = true
        }
      } catch (err) {
        this.html = '<h1>Not Found<h1/>'
        return err
      }
    },
    async fetchTermForCountry () {
      const term = this.terms.find(t => t.name === this.termName)
      if (term) {
        try {
          const { data } = await axios.get(`${this.path}/${term.id}`, {
            headers: {
              'Accept': 'text/html',
            },
          })
          this.html = data
          this.showList = false
        } catch (error) {
          this.html = `<h1>No terms found for ${this.termName}<h1/>`
          console.error('terms not found for', this.termName, error)
        }
      }
    },
    handleTermSelect (term) {
      this.$router.push(`${this.$route.path}?name=${term.name}`)
    },
  },
}
</script>
